import React, { useEffect, useRef, useState } from 'react';
import { Button, Form } from 'react-bootstrap';

import { api_gateway } from '../../../conexoes/api';
import { setaDropdown } from '../../../utils/alternanciaIcones';
import decryptJWT from '../../../utils/decryptJWT';
import SpinerVeye from '../../spinnerVeye/spinnerVeye.js';
export default function SelectFornecedorPlanoFaturas(props) {
    const [spinAtivo, setSpinAtivo] = useState(true);
    const [lsFornecedor, setLsFornecedor] = useState([])
    const modal = useRef();

    const handleClickFora = e => {
        if (!modal.current.contains(e.target)) {
            handleCancelar()
        }
    };

    function handleFornecedorPlanoFaturas(codigo, nome){
        props.setCdFornecedorPlanoFaturas(codigo)
        props.setDsFornecedorPlanoFaturas(nome)
        handleCancelar()
    }

    function handleCancelar(){
        props.setRevelarSelectFornecedorPlanoFaturas(false)
    }

    useEffect(() => {
        setSpinAtivo(true)
        async function renderFornecedor(){
            const {data} = await api_gateway.get('/m1/consultar/fat_fornecedor?cd_pav_usuario='+decryptJWT('codigo'));
            if(data.dados.length > 0){
                let objetoFornecedor = data.dados.map((item,i) => {
                    return (
                        <li key={"menu-"+item.ds_fat_nome_fantasia}>
                            <div className="campo-select-opcao campo-select-opcao-2" onClick={() => handleFornecedorPlanoFaturas(item.cd_fat_fornecedor, item.ds_fat_nome_fantasia) }>
                                <span className="fonte-cor-1 fonte-campo campo-select-opcao-label nao-selecionavel">{item.ds_fat_nome_fantasia}</span>
                            </div>
                            {data.dados[i+1]!=undefined&&<div className="campo-select-divisor-cor-1 campo-select-divisor" />}
                        </li>
                    );
                })
                setLsFornecedor(objetoFornecedor)
            }else{
                let objetoFornecedor = () => {
                    return (
                        <li>
                            <div disabled className="campo-select-opcao campo-select-opcao-1">
                                <span className="fonte-cor-1 fonte-campo campo-select-opcao-label nao-selecionavel">Nenhuma informação encontrada</span>
                            </div>
                        </li>
                    );
                }
                setLsFornecedor(objetoFornecedor)
            }
            setSpinAtivo(false)
        }
        renderFornecedor()
        document.addEventListener('mousedown', handleClickFora);
        return () => document.removeEventListener('mousedown', handleClickFora);

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return(
        <Form ref={modal}>
            { spinAtivo && <div className="componente-spinner-overlay"><div className="componente-spinner-container"><SpinerVeye/></div></div> }
            <Button name="cdTipoPessoa" className="campo-texto-cor-3 campo-select" onClick={() => props.setRevelarSelectFornecedorPlanoFaturas(false)}>
                <div className="fonte-cor-1 label-campo">{props.dsFornecedorPlanoFaturas}</div>
                <img className="campo-select-icone-ativado" src={setaDropdown()} alt="drop" />
            </Button>
            <div className="campo-select-triangulo-cor-1 campo-select-triangulo" />
            <div className="campo-texto-cor-3 campo-select-corpo">
                <ul className="campo-select-lista">
                    {lsFornecedor}
                </ul>
            </div>
        </Form>
    )
}